class FollowUpsApi {
    static setFollowUp(data) {

        return data;
    }
}

export default FollowUpsApi;


// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/followUpApi.js